<template>
	<div v-if="isAuthenticatedUserInGroupAdmin">
		<BaseHeader :title="$t('contract_management').toString()" />
		<div class="main">
			<div v-if="!isLoading">
				<div class="flex flex-col">
					<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" v-if="contracts && contracts?.length > 0">
							<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
								<table class="min-w-full divide-y divide-gray-200">
									<thead>
										<tr>
											<th class="w-full px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('name') }}
											</th>
											<th
												class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
												style="min-width: 150px"
											>
												{{ $t('version') }}
											</th>
											<th
												class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
												style="min-width: 150px"
											>
												{{ $t('accepted_on') }}
											</th>
											<th class="px-6 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"></th>
										</tr>
									</thead>
									<tbody class="bg-white divide-y divide-gray-200">
										<tr class="text-left" v-for="contract in contracts" :key="contract.id" @click="downloadFile(contract.id)">
											<td class="px-6 py-4 cursor-pointer">
												{{ contract.name }}
											</td>
											<td class="px-6 cursor-pointer">
												{{ contract.version }}
											</td>
											<td class="px-6 cursor-pointer">
												{{ getGermanDate(contract.modified) }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div v-else>
							{{ $t('no_contracts_found') }}
						</div>
					</div>
				</div>
			</div>
			<div v-else class="flex flex-grow justify-center w-full opacity-75">
				<LoadingSpinner />
			</div>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Forbidden from '@/views/default/Forbidden.vue';
import Authentication from '@/mixins/Authentication';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import CompanyRepository from '@/api/repositories/CompanyRepository';
import { getGermanDate } from '../../../plugins/Utils';

export default {
	name: 'ContractManagement',
	components: { Forbidden, LoadingSpinner, BaseHeader },
	mixins: [Authentication, AppContainerMixin],
	data() {
		return {
			contracts: [],
			isLoading: false,
		};
	},
	mounted() {
		this.isLoading = true;
		this.getContracts();
	},
	methods: {
		getGermanDate,
		getContracts() {
			new CompanyRepository()
				.getCompanyContracts()
				.then(response => {
					this.contracts = response.data.data;
					this.isLoading = false;
				})
				.catch(e => {});
		},
		downloadFile(id) {
			new CompanyRepository().getCompanyContractByID(id).then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' });
				const name = response.headers['content-disposition'].split('filename=')[1];
				if (this.isAppContainer) {
					const reader = new FileReader();
					reader.onload = function() {
						const arrayBuffer = this.result;
						// convert the ArrayBuffer to a comma-separated string
						const dataString = new Uint8Array(arrayBuffer).join(',');
						const messageData = {
							fileName: name,
							data: dataString,
						};
						// send the data to Swift
						window.webkit.messageHandlers.pdfHandler.postMessage(JSON.stringify(messageData));
					};
					reader.readAsArrayBuffer(blob);
				} else {
					const resolvingUrl = URL.createObjectURL(blob) + '#toolbar=1&navpanes=0&scrollbar=0';
					const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(name)}`;

					setTimeout(function() {
						window.open(viewerUrl, '_blank');
						window.URL.revokeObjectURL(viewerUrl);
					}, 200);
				}
			});
		},
	},
};
</script>
